<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Shop Group')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="cnt">
            <div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="details.tenant_id">{{$t('Tenant')}}</div>
              <multiselect
                v-model="details.tenant_id"
                :options="tenantsList"
                placeholder="Select tenant"
                track-by="brand_name"
                label="brand_name"
              ></multiselect>
            </div>

            <FloatingLabel v-model="details.name" label="Name" size="sm" />

            <FloatingLabel
              v-model="details.description"
              label="Description"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <div class="mb-2 position-relative">
              <div
                class="multiselect-lbl"
                v-if="details.shop_ids && details.shop_ids.length"
              >{{$t('Shops')}}</div>
              <multiselect
                v-model="details.shop_ids"
                :options="shopList"
                placeholder="Select shop"
                :multiple="true"
                track-by="name"
                label="name"
              ></multiselect>
            </div>

            <b-form-group :label="$t('Allow Cross Payment')" class="grouping py-2 px-3 mb-3 mt-0">
              <b-form-checkbox
                v-model="details.allow_cross_payments"
                :value="true"
                :unchecked-value="false"
              >{{$t('Enable Cross Payment')}}</b-form-checkbox>
            </b-form-group>

            <b-form-group :label="$t('Warning Email Addresses')" class="grouping p-3 mb-3 mt-0">
              <ListEditor
                :items="details.warning_email_addresses"
                :addLabel="$t('Add new email')"
                :deleteTootltip="$t('Delete')"
                size="sm"
              />
            </b-form-group>

            <b-form-group :label="$t('Block Email Addresses')" class="grouping p-3 mb-3 mt-0">
              <ListEditor
                :items="details.block_email_addresses"
                :addLabel="$t('Add new email')"
                :deleteTootltip="$t('Delete')"
                size="sm"
              />
            </b-form-group>

            <div class="mb-2 position-relative">
              <div
                class="multiselect-lbl"
                v-if="details.firewall_ruleset_id"
              >{{$t('Firewall Ruleset Id')}}</div>
              <multiselect
                v-model="details.firewall_ruleset_id"
                :options="firewalRulesetList"
                placeholder="Select ruleset"
                track-by="name"
                label="name"
              ></multiselect>
            </div>

            <div style="text-align:right">
              <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ListEditor from "@/components/ListEditor";
import Multiselect from "@/components/multiselect-filters";
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";

export default {
  name: "shopGroup",
  props: ["selectedeid"],
  components: {
    Multiselect,
    ListEditor,
    FloatingLabel
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    Promise.all([
      this.$store.dispatch("cache/fetch", "tenants").catch(e => e),
      this.$store.dispatch("cache/fetch", "shops").catch(e => e),
      this.$store.dispatch("cache/fetch", "firewalls").catch(e => e)
    ]).finally(() => {
      if (this.eid != "0" && this.eid != "") {
        this.loadData();
      } else {
        this.newId = true;
      }
    });
  },
  data: function() {
    return {
      eid: "",
      details: {
        tenant_id: null,
        name: "",
        description: "",
        shop_ids: [],
        allow_cross_payments: false,
        warning_email_addresses: [],
        block_email_addresses: [],
        firewall_ruleset_id: null
      },
      newId: false,
      temp: {}
    };
  },
  computed: {
    tenantsList() {
      const list = this.$store.getters["cache/tenants"];
      return list ? list : [];
    },
    shopList() {
      const self = this;
      const list = this.$store.getters["cache/shops"];

      const tmp = [];
      if (this.details.tenant_id) {
        list.forEach(item => {
          if (item.etenant_id == self.details.tenant_id.eid) {
            tmp.push(item);
          }
        });
      }

      return tmp;
    },
    firewalRulesetList() {
      const list = this.$store.getters["cache/firewalls"];
      return list ? list : [];
    }
  },
  methods: {
    loadData() {
      if (this.eid == "") return;

      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("shopGroup/read", this.eid)
        .then(resp => {
          this.temp = resp.data;
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    onSubmitDetails() {
      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "shopGroup/update";
      if (this.newId) {
        apiAction = "shopGroup/create";
      } else {
        detailsData.eid = this.eid;
      }

      if (detailsData.tenant_id) {
        this.tenantsList.forEach(element => {
          if (element.eid == this.details.tenant_id.eid) {
            detailsData.etenant_id = element.eid;
            return;
          }
        });
      }
      delete detailsData.tenant_id;

      let tmpShopIds = [];
      for (let i = 0; i < detailsData.shop_ids.length; i++) {
        tmpShopIds.push(detailsData.shop_ids[i].eid);
      }
      if (tmpShopIds.length == 0) {
        detailsData.eshop_ids = [];
      } else {
        detailsData.eshop_ids = tmpShopIds;
      }

      if (detailsData.firewall_ruleset_id) {
        this.firewalRulesetList.forEach(element => {
          if (element.eid == this.details.firewall_ruleset_id.eid) {
            detailsData.efirewall_ruleset_id = element.eid;
            return;
          }
        });
      }
      delete detailsData.firewall_ruleset_id;

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Shop group updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Shop group created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.tenant_id = r.etenant_id;
      this.details.name = r.name;
      this.details.description = r.description;
      this.details.allow_cross_payments = r.allow_cross_payments;
      this.details.phone_number = r.phone_number;
      this.details.warning_email_addresses = r.warning_email_addresses
        ? r.warning_email_addresses
        : [];
      this.details.block_email_addresses = r.block_email_addresses
        ? r.block_email_addresses
        : [];
      this.details.firewall_ruleset_id = r.efirewall_ruleset_id;

      if (this.details.tenant_id) {
        this.tenantsList.forEach(element => {
          if (element.eid == this.details.tenant_id) {
            this.details.tenant_id = element;
            return;
          }
        });
      }

      this.details.shop_ids = r.eshop_ids ? r.eshop_ids : [];
      let tmpShopIds = [];
      if (this.details.shop_ids.length > 0) {
        this.shopList.forEach(element => {
          for (let i = 0; i < this.details.shop_ids.length; i++) {
            if (element.eid == this.details.shop_ids[i]) {
              tmpShopIds.push(element);
            }
          }
        });
      }
      this.details.shop_ids = tmpShopIds;

      if (this.details.firewall_ruleset_id) {
        this.firewalRulesetList.forEach(element => {
          if (element.eid == this.details.firewall_ruleset_id) {
            this.details.firewall_ruleset_id = element;
            return;
          }
        });
      }
    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Shop Group", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
